import { useCallback, useEffect, useState } from 'react';

import { ExternalContextInterface, I18N, LANGS } from '@ps-int/general-themes-components/contexts';
import { TLocale } from '@ps-int/general-themes-components/locales/i18n';

import { getStore } from '../../../../../../init-store';
import { getLocale, importLocale } from './locales';

export function useGeneralThemesI18n(): ExternalContextInterface {
    const currentLang: typeof LANG = getStore().getState().config.appLang;
    const userLang = (LANGS as unknown as string[]).includes(currentLang) ? (currentLang as typeof LANG) : 'ru';

    const [locale, setLocale] = useState<null | TLocale>(null);

    useEffect(() => {
        (async () => {
            await importLocale(userLang);

            const locale = getLocale();

            setLocale(locale);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getLocaleKey: I18N = useCallback(
        <TKey extends keyof TLocale>(key: TKey) => {
            return locale?.[key] as TLocale[TKey];
        },
        [locale]
    );

    return {
        i18n: locale ? getLocaleKey : null,
    };
}
